<template lang="pug">
    .panel
        .panel-heading
            .panel-title Установка <b>виджета</b>
        .panel-body
            .panel.white-background
                .panel-body
                    p Данный код необходимо вставить в раздел 
                        | <code>&lt;head&gt;</code> страницы:
                    .vfl-field.form-group.input-icon.input-icon-right
                        input(
                            type="text",
                            :value="widgetSrc", 
                            readonly="",
                            style="padding-left: 0!important;"
                        )
                        i.fa.fa-clipboard(
                            style="cursor: pointer;", 
                            title="Скопировать",
                            @click="copyToClipboard"
                        )
                        span.field-underline
                    p Функцию <code>SB.init</code> можно вызывать из 
                        | <code>javascript</code> в любом удобном месте 
                        | (главное, чтобы вызов этой фунции происходил <b>после
                        | </b> выполнения первого скрипта). Например, 
                        |  можно вставить в тег <code>head</code> после 
                        | первого скрипта:
                    .vfl-field.form-group.input-icon.input-icon-right
                        textarea(
                            :value="widgetScript", 
                            style="height: 290px;",
                            readonly=""
                        )
                        i.fa.fa-clipboard(
                            style="cursor: pointer;", 
                            title="Скопировать",
                            @click="copyToClipboard"
                        )
                        span.field-underline
                    p Обратите внимание, что в <code>init</code> функцию необходимо 
                        | передать следующие параметры: 
                        ul
                            li <code>token</code> &mdash; API токен магазина 
                            li <code>price_to_pay</code> &mdash; сумма наложенного платежа в рублях 
                            li <code>price_insurance</code> &mdash; объявленная стоимость для страховки в рублях 
                            li <code>weight</code> &mdash; вес в г 
                            li <code>x</code>, <code>y</code>, <code>z</code> &mdash; опционально (но желательно) размеры в см. 
                                | Если размеры не пераданы, будет считаться, что размеры подходят для минимального тарифа. 
                            li <code>city_by</code> &mdash; строковое значение <i>"ip"</i>, если город посетителя 
                                | необходимо определить автоматически по его IP адресу, или 
                                | <i>"city_code"</i>, если идентификатор города передаётся 
                                | вручную в виджет в отдельном параметре <code>city_code</code>
                            li <code>params_by</code> &mdash; принимает строковое значение <i>"params"</i>, 
                                | если вес и размеры товара передаются в отдельных параметрах <code>weight</code>, 
                                | <code>x</code>, <code>y</code>, <code>z</code>; или <i>"product_id"</i>, 
                                | если в систему загружены продукты с проставленными размерами 
                                | и весами, тогда вместо явной передачи размеров и веса в 
                                | виджет можно передать только идентификатор (артикул) продукта в 
                                | отдельном параметре <code>product_id</code>.
                            li <code>callback</code> &mdash; опциональная JavaScript функция, которая 
                                | вызовется после добавления виджета на страницу.
                                | Может быть использован, если изначально виджет скрыт и по нажатию на какой-то элемент 
                                | на странице (ссылка «доставка») нужно инициализировать виджет и отобразить div с ним
                            li <code>main_div_id</code> &mdash; идентификатор div 
                                | элемента, в который вставится виджет. Сам div элемент с 
                                | данным идентификатором необходимо вставить в HTML код 
                                | страницы в нужном месте, куда планируется добавление 
                                | виджета:
                    .vfl-field.form-group.input-icon.input-icon-right
                        input(
                            type="text",
                            :value="widgetDiv", 
                            readonly="",
                            style="padding-left: 0!important;"
                        )
                        i.fa.fa-clipboard(
                            style="cursor: pointer;", 
                            title="Скопировать",
                            @click="copyToClipboard"
                        )
                        span.field-underline
                    p Вот и виджет готов! А если вы хотите изменить его внешний вид, 
                        | настройте его с помощью конфигуратора <a href="#/widget">здесь</a>, 
                        | там же в расширенных настройках можно ввести необходимые CSS параметры 
                        | для изменения дизайна виджета.
    
</template>

<script>
export default {
    name: 'InstallationGuide',
    props: {
        token: String
    },
    computed: {
        widgetScript() {
            return `<script> 
    SB.init({
        token: '${this.token}',
        price_to_pay: 5000,
        price_insurance: 5000,
        weight: 200,
        x: 20,
        y: 10,
        z: 3,
        city_by: 'ip',
        params_by: 'params',
        main_div_id: 'salesbeat-deliveries-1',
        callback: function(){
            console.log('Salesbeat готов');
        }
    });
<\/script>`;
        }

    },
    methods: {
        copyToClipboard(event) {
            let input = event.target.parentNode.querySelector('input,textarea');
            input.select();

            document.execCommand('Copy');
        }
    },
    data() {
        let widgetSrc = '<script src="https://app.salesbeat.pro/static/widget/js/widget.js" charset="UTF-8"><\/script>';
        let widgetDiv = '<div id="salesbeat-deliveries-1" class="salesbeat-deliveries"></div>';

        return {
            widgetDiv, widgetSrc
        };
    }
};
</script>


// WEBPACK FOOTER //
// src/components/shops/InstallationGuide.vue